import { motion } from "framer-motion";
import { fadeUp, slideLeft } from "../../animations/variants";

import { useSelector } from "react-redux";
import { achieversHeroText } from "../../i18n/achieversHero";

const AchieversHero = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = achieversHeroText[lang];
  return (
    <section className="bg-darkbg text-white pt-32 px-6 overflow-hidden h-screen">
      {/* TOP HERO IMAGE */}
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="max-w-5xl mx-auto flex justify-center mb-12"
      >
        <div className="w-full max-w-3xl overflow-hidden rounded-b-full shadow-2xl">
          <img
            src="/images/tb12.jpg"
            className="w-full h-[400px] md:h-[500px] object-cover grayscale-[20%] brightness-90"
          />
        </div>
      </motion.div>

      {/* TITLE */}
      <motion.h1
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="text-center text-3xl md:text-4xl font-heading text-yellow mb-6"
      >
        {t.title}
      </motion.h1>

      {/* SUBTITLE */}
      <motion.p
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="text-center text-text text-lg max-w-2xl mx-auto mb-14"
      >
        {t.subtitle}
      </motion.p>

      {/* DIVIDER */}
      {/* <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="max-w-4xl mx-auto flex items-center justify-between mb-12"
      >
        <div className="border-t border-gray-700 w-full"></div>
        <span className="px-3 text-sm text-gray-400 tracking-wide">
          Success Stories
        </span>
        <div className="border-t border-gray-700 w-full"></div>
      </motion.div> */}
    </section>
  );
};

export default AchieversHero;
